import React from 'react'
import './MiscFooter.css'

const MiscFooter = () => {
  return (
		<div className='misc-footer-container'>
			<center><p>© {new Date().getFullYear()}  SKILLOP &nbsp; All Rights Reserved.</p></center>
		</div>
	);
}

export default MiscFooter;